import { Checkbox, FormControlLabel, Stack } from '@mui/material'
import PaduRow from './PaduRow'
import { EditorField } from './schemaEditorReducer'

interface P {
    field: EditorField
    onUpdateField: (
        fieldId: string,
        updates: Partial<EditorField>
    ) => void
}

const PaduConfig = ({ field, onUpdateField }: P) => {
    return (
        <Stack spacing={2}>
            <FormControlLabel
                control={(
                    <Checkbox
                        checked={!!field.padu}
                        onChange={(_, checked) => {
                            const defaultOperation = field.type === 'string' ? 'equal' : 'greater'

                            onUpdateField(field._id, {
                                padu: checked
                                    ? {
                                            preferred: { operation: defaultOperation, value: undefined },
                                            acceptable: { operation: defaultOperation, value: undefined },
                                            discouraged: { operation: defaultOperation, value: undefined },
                                            unacceptable: { operation: defaultOperation, value: undefined }
                                        }
                                    : undefined
                            })
                        }}
                    />
                )}
                label='Set PADU Values'
            />
            {field.padu && (
                <Stack spacing={2}>
                    <PaduRow
                        type='preferred'
                        field={field}
                        onUpdateField={onUpdateField}
                    />
                    <PaduRow
                        type='acceptable'
                        field={field}
                        onUpdateField={onUpdateField}
                    />
                    <PaduRow
                        type='discouraged'
                        field={field}
                        onUpdateField={onUpdateField}
                    />
                    <PaduRow
                        type='unacceptable'
                        field={field}
                        onUpdateField={onUpdateField}
                    />
                </Stack>
            )}
        </Stack>
    )
}

export default PaduConfig
